export type AddSimsQuote = {
  existingQuantity: number;
  newQuantity: number;
  unitPrice: number;
  total: number;
  changesUnitPrice: boolean;
};

export const normaliseSimQuantity = (quantity?: number): number => {
  if (typeof quantity !== 'number' || !Number.isFinite(quantity) || quantity < 1) return 1;
  return Math.floor(quantity);
};

export const getAddSimsQuote = (
  existingQuantity: number | undefined,
  addedQuantity: number,
  unitPriceInput: string,
  currentUnitPrice: number
): AddSimsQuote | null => {
  const trimmedPrice = unitPriceInput.trim();
  if (trimmedPrice === '') return null;
  const parsedPrice = Number(trimmedPrice);
  if (!Number.isFinite(parsedPrice) || parsedPrice < 0) return null;

  const currentQuantity = normaliseSimQuantity(existingQuantity);
  const safeAddedQuantity = Math.max(0, Math.floor(addedQuantity));
  const unitPriceMinor = Math.round(parsedPrice * 100);
  const currentUnitPriceMinor = Math.round(currentUnitPrice * 100);
  const unitPrice = unitPriceMinor / 100;
  const newQuantity = currentQuantity + safeAddedQuantity;

  return {
    existingQuantity: currentQuantity,
    newQuantity,
    unitPrice,
    total: (unitPriceMinor * newQuantity) / 100,
    changesUnitPrice: unitPriceMinor !== currentUnitPriceMinor
  };
};
